import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ImageUploadModel } from "../../../../model/jubili/upload-image/Image-upload-model";
import { environment } from "../../../../../environments/environment";
import { SettingService } from "../../../../service/api/jubili/setting.service";
import { LocalStorageService } from "angular-2-local-storage";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit {

  constructor(
    private readonly route: ActivatedRoute,
    private settingService: SettingService,
    private localStorageService: LocalStorageService,
    private readonly modalService: BsModalService,
  ) {
  }

  imageList = new Array<ImageUploadModel>()
  companyId: number;
  loading = false;
  modalRef: BsModalRef;
  textModal = ""

  @ViewChild("successModal") successModal: TemplateRef<any>;
  sizeLimit = 2048000;

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.companyId = Number(params.get("id"));
    });
    // this.addColumn();
  }


  addColumn(): void {
    let item = new ImageUploadModel();
    if (this.imageList.length < 100) {
      item.imageName = "";
      item.imageThumbnail = "";
      item.imageOriginal = "";
      this.imageList.push(item);
    }
  }

  delete(index: number): void {
    let temp = new Array<ImageUploadModel>();
    for (let i = 0; i < this.imageList.length; i++) {
      if (i != index) temp.push(this.imageList[i]);
    }
    this.imageList = temp;
  }

  getImagePath(path: string): string {
    if (!path || /^\s*$/.test(path)) {
      return "";
    }

    const isNewFormat = /^PROD\/\d+\/.+/.test(path);
    const basePath = isNewFormat ? environment.jubiliPathS3NewFormat : environment.jubiliPathS3;

    return basePath + path;
  }

  splitType(fileName: string): string {
    const png = ".png";
    const jpg = ".jpg";
    const jpeg = ".jpeg";
    if (fileName.toLowerCase().includes(png)) return fileName.slice(0, fileName.length - png.length);
    else if (fileName.toLowerCase().includes(jpg)) return fileName.slice(0, fileName.length - jpg.length);
    else if (fileName.toLowerCase().includes(jpeg)) return fileName.slice(0, fileName.length - jpeg.length);
    return fileName;
  }

  validNameDuplicate(name: string): boolean {
    const item = this.splitType(name);
    for (let i = 0; i < this.imageList.length; i++) {
      if (this.imageList[i].imageName === item) return true;
    }
    return false;
  }

  uploadImage(eventFile: any, index: number) {
    if (eventFile !== undefined) {
      if (!this.validNameDuplicate(eventFile.name)) {
        this.imageList[index].imageName = this.splitType(eventFile.name);
        this.imageList[index].imageType = eventFile.type;
        this.settingService.uploadImage(eventFile, this.companyId).subscribe(response => {
          if (response !== null) {
            this.imageList[index].imageOriginal = response.originalImagePath
            this.imageList[index].imageThumbnail = response.resizeImagePath;
          }
        });
      } else {
        this.imageList[index] = new ImageUploadModel()
        this.imageList[index].imageName = "";
        this.imageList[index].imageThumbnail = "";
        this.imageList[index].imageOriginal = "";
        this.imageList[index].imageType = "";
        alert('Image Name Duplicate');
      }
    } else {
      this.imageList[index].imageName = "";
      this.imageList[index].imageType = "";
    }
  }

  validate(): boolean {
    if (this.imageList.length === 0) return false;
    for (let i = 0; i < this.imageList.length; i++) {
      if (this.imageList[i].imageName === "") return false;
    }
    return true;
  }

  onSave(): void {
    let userId = this.localStorageService.get<string>("userSurrKey");
    this.loading = true;
    this.settingService.uploadImageListImport(this.imageList, this.companyId, parseInt(userId)).subscribe(response => {
      if (response) {
        this.imageList = new Array<ImageUploadModel>();
        this.loading = false;
        this.textModal = "Import Image Success";
        this.modalRef = this.modalService.show(this.successModal, {
          class: "modal-md modal-dialog-centered",
          backdrop: "static",
          keyboard: false
        });
      } else {
        this.textModal = "Impost Image Failed";
        this.modalRef = this.modalService.show(this.successModal, {
          class: "modal-md modal-dialog-centered",
          backdrop: "static",
          keyboard: false
        });
        this.loading = false;
      }
    });
  }

  selectMore($event: any): void {
    if ($event === undefined) return;
    if ($event.target.files.length > 0) {
      this.loading = true;
      for (let i = 0; i < $event.target.files.length; i++) {
        let file = $event.target.files[i];
        if (file.size < this.sizeLimit) {
          if (!this.validNameDuplicate(file.name)) {
            if (this.imageList.length < 100) {
              this.settingService.uploadImage(file, this.companyId).subscribe(response => {
                if (response !== null) {
                  let newImage = new ImageUploadModel();
                  newImage.imageName = this.splitType(file.name);
                  newImage.imageType = file.type;
                  newImage.imageOriginal = response.originalImagePath
                  newImage.imageThumbnail = response.resizeImagePath;
                  this.imageList.push(newImage);
                }
              });
            } else { alert('Image Max 100 Item'); }
          } else {
            alert('Image Name Duplicate');
          }
        } else {
          alert('The image size cannot exceed 2MB');
        }
      }
      this.loading = false;
    }
  }

  maxSizeValid($event: boolean) {
    if ($event) alert('The image size cannot exceed 2MB');
  }
}
